import { EmailContactData } from '../../../../../models/EmailContact';
import CopyContactIdButton from '../CopyContactIdButton/CopyContactIdButton';
import { formatReceivedAt } from '../../../../../utils/emailContactHelpers';
import { Paperclip } from '@coolblue-development/icons';
import { Box, Typography } from '@coolblue-development/freddy';

interface EmailHeaderExpandedProps {
  data: EmailContactData;
}

const EmailHeaderExpanded = ({ data }: EmailHeaderExpandedProps): JSX.Element => {
  const { customerName, from, contactId, receivedAt, otherRecipients } = data;
  // The first `to` address is the delivered-to address; everyone else is already in otherRecipients.
  const to = data.to?.slice(0, 1);
  return (
    <Box data-testid="email-header-expanded">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>
          {customerName && (
            <Typography variant="h6" data-testid="email-customer-name">
              {customerName}
            </Typography>
          )}

          {from && (
            <Typography variant="caption" color="subtle" data-testid="email-from" fontWeight={500}>
              {'<'}
              {from}
              {'>'}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
            alignItems: 'center',
            flexShrink: 0,
            whiteSpace: 'nowrap',
            overflowWrap: 'normal'
          }}
        >
          {data.hasAttachments && <Paperclip color="#868A90" />}
          <CopyContactIdButton contactId={contactId} />

          {receivedAt && (
            <Typography variant="caption" data-testid="email-received-at" fontWeight={500}>
              {formatReceivedAt(receivedAt)}
            </Typography>
          )}
        </Box>
      </Box>

      {((to && to.length > 0) || (otherRecipients && otherRecipients.length > 0)) && (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
          {to && to.length > 0 && (
            <Typography variant="caption" color="subtle" data-testid="email-to" fontWeight={500}>
              To: {to.join(', ')}
            </Typography>
          )}

          {otherRecipients && otherRecipients.length > 0 && (
            <Typography variant="caption" color="subtle" data-testid="email-other-recipients" fontWeight={500}>
              Other recipients: {otherRecipients.join(', ')}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default EmailHeaderExpanded;
